import React, {Component} from "react";

import * as AdminClassroomService from "../../../services/Teacher/AdminClassroomService";
import * as UserService from "../../../services/User/UserService";
import * as OnlineService from '../../../services/Online/OnlineService';

const initState = {
    classroomName: null,
    isClassroomNameDuplicated: null,
    searchByNameValue: null,
    searchByNameContent: [],
    registerStudentList: [],
    updateStudentList: [],
    isUpdateMod: false,
    visible: false,
    file: undefined,
    videoList: []
};

class PopupAdminClassroom extends Component {
    state = {
        classroomName: null,
        classroomNameUpdate: null,
        originalClassroomNameUpdate: null,
        isClassroomNameDuplicated: null,
        searchByNameValue: null,
        searchByNameContent: [],
        registerStudentList: [],
        updateStudentList: [],
        isLoaded: false,
        visible: false,
        file: undefined,
        videoList: []
    };

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            isUpdateMod: nextProps.isUpdateMod,
            isLoaded: nextProps.isLoaded,
            classroomNameUpdate: nextProps.classroomNameUpdate,
            originalClassroomNameUpdate: nextProps.classroomNameUpdate,
            visible: nextProps.active
        });
    }

    closePopup = () => {
        this.setState(initState);
        this.props.onClose();
    }

    enterKeyPress = (e) => {
        const name = e.target.name;
        if (e.keyCode === 13) {
            if (name === 'classroomDuplicateNameCheck' || name === 'classroomUpdateDuplicateNameCheck') {
                this.classroomDuplicateNameCheck();
            } else if (name === 'searchUserName') {
                this.searchUserName();
            }
        } else if (name === 'classroomDuplicateNameCheck' && (this.state.classroomName == null || (this.state.classroomName != null && this.state.classroomName.trim().isEmpty))) {
            this.setState({
                isClassroomNameDuplicated: true
            });
        } else if (name === 'classroomUpdateDuplicateNameCheck' && (this.state.classroomNameUpdate == null || (this.state.classroomNameUpdate != null && this.state.classroomNameUpdate.trim().isEmpty))) {
            this.setState({
                isClassroomNameDuplicated: true
            });
        }
    }

    classroomDuplicateNameCheck = () => {
        let checkNameOfClassroom = null;
        if (this.state.classroomName != null && !this.state.classroomName.trim().isEmpty) {
            checkNameOfClassroom = this.state.classroomName;
        } else if (this.state.classroomNameUpdate != null && !this.state.classroomNameUpdate.trim().isEmpty) {
            checkNameOfClassroom = this.state.classroomNameUpdate;
        }
        if (checkNameOfClassroom == null || (checkNameOfClassroom != null && checkNameOfClassroom.trim().isEmpty)) {
            return false;
        }
        AdminClassroomService.duplicateClassroomCheck(checkNameOfClassroom).then((response) => {
            if (response !== null && response.status === 200) {
                if (response.data !== null && response.data.code === '0000') {
                    this.setState({
                        isClassroomNameDuplicated: false
                    });
                } else if (response.data !== null && response.data.code === '0005') {
                    this.setState({
                        isClassroomNameDuplicated: true
                    });
                    alert('이미 생성된 학급 입니다.');
                } else {
                    console.log(response);
                    alert('SERVER ERROR');
                }
            }
        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    searchUserName = () => {
        if (this.state.searchByNameValue == null || (this.state.searchByNameValue != null && this.state.searchByNameValue.isEmpty)) {
            return false;
        }
        UserService.searchByNameInStudent(this.state.searchByNameValue).then((response) => {
            if (response !== null && response.status === 200) {
                if (response.data !== null && response.data.code === '0000') {
                    this.setState({
                        searchByNameContent: response.data.data
                    });
                } else {
                    this.setState({
                        searchByNameContent: []
                    });
                    alert(response.data.data);
                }
            } else {
                console.log(response);
                alert('SERVER ERROR');
            }
        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    registerAddStudent = (student) => {
        let arrayList = [...this.state.registerStudentList];
        if (arrayList.indexOf(student) == -1) {
            arrayList.push(student);
            this.setState({
                registerStudentList: arrayList
            });
        }
    }
    registerRemoveStudent = (student) => {
        let arrayList = [...this.state.registerStudentList];
        let index = arrayList.indexOf(student);
        arrayList.splice(index, 1);
        this.setState({
            registerStudentList: arrayList
        });
    }
    updateAddStudent = (student) => {
        let arrayList = [...this.state.updateStudentList];
        if (arrayList.indexOf(student) == -1) {
            arrayList.push(student);
            this.setState({
                updateStudentList: arrayList
            });
        }
    }
    updateRemoveStudent = (student) => {
        let arrayList = [...this.state.updateStudentList];
        let index = arrayList.indexOf(student);
        arrayList.splice(index, 1);
        this.setState({
            updateStudentList: arrayList
        });
    }

    createClassroom = () => {
        if (this.state.classroomName == null || (this.state.classroomName != null && this.state.classroomName.trim().isEmpty)) {
            alert('학급 이름을 입력해주세요.')
            return false;
        }
        if (this.state.isClassroomNameDuplicated == null || (this.state.isClassroomNameDuplicated != null && this.state.isClassroomNameDuplicated == true)) {
            alert('학급 이름을 다시 입력해주세요.')
            return false;
        }
        AdminClassroomService.createClassroomAndMappingStudent(this.state.classroomName, this.state.registerStudentList).then((response) => {
            if (response !== null && response.status === 200) {
                if (response.data !== null && response.data.code === '0000') {
                    alert('신규 학급이 생성 되었습니다.');
                    this.setState(initState);
                    this.closePopup();
                }
            } else {
                console.log(response);
                alert('SERVER ERROR');
            }
        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    getStudentList = (classroomName) => {
        AdminClassroomService.getStudentList(classroomName).then((response) => {
            if (response !== null && response.status === 200) {
                if (response.data !== null && response.data.code === '0000') {
                    this.setState({
                        updateStudentList: response.data.data
                    });
                    this.getVideoList();
                } else {
                    this.setState({
                        updateStudentList: []
                    });
                    alert(response.data.data);
                }
            } else {
                console.log(response);
                alert('SERVER ERROR');
            }
        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    updateClassroom = () => {
        if (this.state.originalClassroomNameUpdate != this.state.classroomNameUpdate) {
            if (this.state.isClassroomNameDuplicated == null || (this.state.isClassroomNameDuplicated != null && this.state.isClassroomNameDuplicated == true)) {
                alert('학급 이름을 다시 입력해주세요.')
                return false;
            }
        }
        AdminClassroomService.updateClassroomAndMappingStudent(this.state.classroomNameUpdate, this.state.originalClassroomNameUpdate, this.state.updateStudentList).then((response) => {
            if (response !== null && response.status === 200) {
                if (response.data !== null && response.data.code === '0000') {
                    alert('학급이 수정 되었습니다.');
                    this.setState(initState);
                    this.closePopup();
                }
            } else {
                console.log(response);
                alert('SERVER ERROR');
            }
        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    deleteClassroom = () => {
        let deleteClassroom = window.prompt('학급을 삭제하기 위해 삭제할 학급 명을 적어주세요.\n' + this.state.classroomNameUpdate + ' 학급을 삭제 하겠습니까?');
        if (deleteClassroom == this.state.classroomNameUpdate) {
            AdminClassroomService.deleteClassroomAndMappingStudent(this.state.classroomNameUpdate).then((response) => {
                if (response !== null && response.status === 200) {
                    if (response.data !== null && response.data.code === '0000') {
                        alert('학급이 삭제 되었습니다.');
                        this.setState(initState);
                        this.closePopup();
                    }
                } else {
                    console.log(response);
                    alert('SERVER ERROR');
                }
            }).catch((error) => {
                console.log(error);
                alert('SERVER ERROR');
            });
        } else {
            alert('삭제할 학급을 적어주세요.');
            return false;
        }
    };

    onHandleChange = (event) => {
        let file = event.target.files[0];
        this.setState({file: file});
    };

    onHandleSubmit = (event) => {
        if (this.state.file == null || this.state.file === '') {
            alert('저장할 동영상이 없습니다');
            return false;
        }
        alert('동영상 저장 시작 ...');
        this.setState({
            isLoadingHide: false
        });
        let formData = new FormData();
        formData.append('file', this.state.file, this.state.file.name);
        const that = this;
        AdminClassroomService.saveVideo(this.state.classroomNameUpdate, formData).then((response) => {
            if (response.status === 200) {
                let responseData = response.data;
                if (responseData.code === '0000') {
                    alert('동영상 저장 성공');
                    this.getVideoList();
                } else {
                    alert(responseData.data);
                }
            } else {
                alert('동영상 저장 ERROR');
            }
            that.setState({
                isLoadingHide: true
            });
        }).catch(response => {
            alert("SERVER ERROR" + response);
            that.setState({
                isLoadingHide: true
            });
        });
    };

    getVideoList = () => {
        const that = this;
        this.setState({isLoadingHide: false});
        if (this.state.classroomNameUpdate != null && this.state.classroomNameUpdate !== '') {
            OnlineService.getVideoListByClassroom(this.state.classroomNameUpdate).then((response) => {
                if (response.status === 200) {
                    let responseData = response.data;
                    if (responseData.code === '0000') {
                        that.setState({isLoaded: true, videoList: responseData.data != null ? responseData.data : []});
                    } else {
                        alert(responseData.data);
                    }
                } else {
                    alert('동영상 정보 조회 실패');
                }
                that.setState({
                    isLoadingHide: true
                });
            }).catch(response => {
                alert("SERVER ERROR" + response);
                that.setState({
                    isLoadingHide: true
                });
            });
        } else {
            this.setState({videoList: []});
        }
    };

    updateVideoList = (classroomName, videoPathName) => {
        const that = this;
        if (classroomName != null && classroomName !== '' && videoPathName != null && videoPathName !== '') {
            OnlineService.updateVideoListByClassroom(classroomName, videoPathName).then((response) => {
                if (response.status === 200) {
                    let responseData = response.data;
                    if (responseData.code === '0000') {
                        this.getVideoList();
                    } else {
                        alert(responseData.data);
                    }
                } else {
                    alert('동영상 삭제 실패');
                }
                that.setState({
                    isLoadingHide: true
                });
            }).catch(response => {
                alert("SERVER ERROR" + response);
                that.setState({
                    isLoadingHide: true
                });
            });
        } else {
            this.setState({videoList: []});
        }
    };

    updateClassroomComponent = () => {
        if (this.state.isLoaded == false) {
            this.getStudentList(this.props.classroomNameUpdate);
        }
        return (
            <div className="popupWrapper admin">
                <div className="popup">
                    <div className="formWrapper">
                        <div className="joinForm">
                            <fieldset>
                                <legend className="screenOut">학급 수정하기</legend>
                                <dl className="formContents">
                                    <dt className="title">
                                        <span>학급 상세</span>
                                        <button className="btnClose" onClick={this.closePopup}>닫기</button>
                                    </dt>
                                    <dd className="contents">
                                        <div className="tabContents">
                                            <ul>
                                                <li>
                                                    <div className="inputWrapper">
                                                        <ul>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label>
                                                                        <span
                                                                            style={(this.state.isClassroomNameDuplicated == true) ? {color: 'red'} : null}>*학급 이름</span>
                                                                            <div className="wrap-search">
                                                                            <input className="ip-basic" type="text"
                                                                                   name="classroomUpdateDuplicateNameCheck"
                                                                                   defaultValue={this.state.classroomNameUpdate}
                                                                                   onChange={e => this.setState({classroomNameUpdate: e.target.value})}
                                                                                   onKeyUp={this.enterKeyPress}
                                                                                   placeholder="학급 이름 입력"/>
                                                                            <a className="btn-sm deepPink"
                                                                               style={{display: (this.state.classroomNameUpdate == this.state.originalClassroomNameUpdate) ? 'none' : 'block'}}
                                                                               onClick={this.classroomDuplicateNameCheck}>중복체크</a>
                                                                            <span className="duplicate"
                                                                                  hidden={!(this.state.isClassroomNameDuplicated == false)}>이용가능</span>
                                                                        </div>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label>
                                                                        <span>학생 이름 검색</span>
                                                                        <div className="wrap-search">
                                                                          <input className="ip-basic" type="text"
                                                                                 name="searchUserName"
                                                                                 onChange={e => this.state.searchByNameValue = e.target.value}
                                                                                 onKeyUp={this.enterKeyPress}
                                                                                 placeholder="학생 이름 검색"/>
                                                                          <a className="btn-sm yellow"
                                                                             onClick={this.searchUserName}>검색</a>
                                                                        </div>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label>
                                                                        <span>동영상 업로드</span>
                                                                        <div>
                                                                            <input type="file"
                                                                                   onChange={this.onHandleChange}/>
                                                                            <button onClick={this.onHandleSubmit}
                                                                                    style={{
                                                                                        border: '1px solid red',
                                                                                        cursor: 'pointer',
                                                                                        height: '30px'
                                                                                    }}>동영상 저장</button>
                                                                        </div>
                                                                    </label>

                                                                </span>
                                                            </li>
                                                            <li className="box-student"
                                                                hidden={this.state.searchByNameContent == null || this.state.searchByNameContent.length <= 0}>
                                                                <table className="tb-basic">
                                                                    <colgroup>
                                                                        <col width="30%"/>
                                                                        <col width="15%"/>
                                                                        <col width="25%"/>
                                                                        <col width="30%"/>
                                                                    </colgroup>
                                                                    <thead>
                                                                    <tr>
                                                                        <th>학교</th>
                                                                        <th>학년</th>
                                                                        <th>이름</th>
                                                                        <th>등록하기</th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {this.state.searchByNameContent.map((content, i) =>
                                                                        <tr key={i}>
                                                                            <td>{content.school}</td>
                                                                            <td>{content.grade}</td>
                                                                            <td>{content.name}</td>
                                                                            <td>
                                                                                <a className="btn-sm deepPink"
                                                                                   onClick={() => this.updateAddStudent(content)}>등록</a>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                    </tbody>
                                                                </table>
                                                            </li>
                                                            <li hidden={this.state.updateStudentList == null || this.state.updateStudentList.length <= 0}>
                                                                <span className="customInputBox">
                                                                    <ul className="list-student">
                                                                        {this.state.updateStudentList.map((student, i) =>
                                                                            <li key={i}>
                                                                                <span>{student.name}</span>
                                                                                <a href="javascript:"
                                                                                   onClick={() => this.updateRemoveStudent(student)}>x</a>
                                                                            </li>
                                                                        )}
                                                                    </ul>
                                                                </span>
                                                            </li>
                                                            <li hidden={this.state.videoList != null && this.state.videoList.length <= 0}
                                                                className="box-student">
                                                                <ul>
                                                                    {this.state.videoList.map((video, key) =>
                                                                        <li key={video + key}
                                                                            onClick={() => this.updateVideoList(this.state.classroomNameUpdate, video)}
                                                                            style={{cursor: 'pointer'}}>
                                                                            <span style={{
                                                                                display: 'block',
                                                                                fontSize: '13pt'
                                                                            }}>{video} (클릭 삭제)</span>
                                                                        </li>
                                                                    )}
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="btnWrapper">
                                                        <a className="baseBtn blue" onClick={this.updateClassroom}>
                                                            <span>수정하기</span>
                                                        </a>
                                                        <a className="baseBtn deepPink" onClick={this.deleteClassroom}>
                                                            <span>삭제하기</span>
                                                        </a>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </dd>
                                </dl>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            this.state.visible ?
                this.state.isUpdateMod ?
                    <div>
                        {this.updateClassroomComponent()}
                    </div>
                    : <div className="popupWrapper admin">
                        <div className="popup">
                            <div className="formWrapper">
                                <div className="joinForm">
                                    <fieldset>
                                        <legend className="screenOut">새 학급 만들기</legend>
                                        <dl className="formContents">
                                            <dt className="title">
                                                <span>새 학급 만들기</span>
                                                <button className="btnClose" onClick={this.closePopup}>닫기</button>
                                            </dt>
                                            <dd className="contents">
                                                <div className="tabContents">
                                                    <ul>
                                                        <li>
                                                            <div className="inputWrapper">
                                                                <ul>
                                                                    <li>
                                                                <span className="customInputBox">
                                                                    <label>
                                                                        <span
                                                                            style={(this.state.isClassroomNameDuplicated == true) ? {color: 'red'} : null}>*학급 이름</span>
                                                                            <div className="wrap-search">
                                                                            <input className="ip-basic" type="text"
                                                                                   name="classroomDuplicateNameCheck"
                                                                                   onChange={e => this.state.classroomName = e.target.value}
                                                                                   onKeyUp={this.enterKeyPress}
                                                                                   placeholder="학급 이름 입력"/>
                                                                            <a className="btn-sm deepPink"
                                                                               onClick={this.classroomDuplicateNameCheck}>중복체크</a>
                                                                            <span className="duplicate"
                                                                                  hidden={!(this.state.isClassroomNameDuplicated == false)}>이용가능</span>
                                                                        </div>
                                                                    </label>
                                                                </span>
                                                                    </li>
                                                                    <li>
                                                                <span className="customInputBox">
                                                                    <label>
                                                                        <span>학생 이름 검색</span>
                                                                        <div className="wrap-search">
                                                                          <input className="ip-basic" type="text"
                                                                                 name="searchUserName"
                                                                                 onChange={e => this.state.searchByNameValue = e.target.value}
                                                                                 onKeyUp={this.enterKeyPress}
                                                                                 placeholder="학생 이름 검색"/>
                                                                          <a className="btn-sm yellow"
                                                                             onClick={this.searchUserName}>검색</a>
                                                                        </div>
                                                                    </label>
                                                                </span>
                                                                    </li>
                                                                    <li className="box-student"
                                                                        hidden={this.state.searchByNameContent == null || this.state.searchByNameContent.length <= 0}>
                                                                        <table className="tb-basic">
                                                                            <colgroup>
                                                                                <col width="30%"/>
                                                                                <col width="15%"/>
                                                                                <col width="25%"/>
                                                                                <col width="30%"/>
                                                                            </colgroup>
                                                                            <thead>
                                                                            <tr>
                                                                                <th>학교</th>
                                                                                <th>학년</th>
                                                                                <th>이름</th>
                                                                                <th>등록하기</th>
                                                                            </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            {this.state.searchByNameContent.map((content, i) =>
                                                                                <tr key={i}>
                                                                                    <td>{content.school}</td>
                                                                                    <td>{content.grade}</td>
                                                                                    <td>{content.name}</td>
                                                                                    <td>
                                                                                        <a className="btn-sm deepPink"
                                                                                           onClick={() => this.registerAddStudent(content)}>등록</a>
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                            </tbody>
                                                                        </table>
                                                                    </li>
                                                                    <li hidden={this.state.registerStudentList == null || this.state.registerStudentList.length <= 0}>
                                                                <span className="customInputBox">
                                                                    <ul className="list-student">
                                                                        {this.state.registerStudentList.map((student, i) =>
                                                                            <li key={i}>
                                                                                <span>{student.name}</span>
                                                                                <a href="javascript:"
                                                                                   onClick={() => this.registerRemoveStudent(student)}>x</a>
                                                                            </li>
                                                                        )}
                                                                    </ul>
                                                                </span>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div className="btnWrapper">
                                                                <a className="baseBtn deepPink"
                                                                   onClick={this.createClassroom}>
                                                                    <span>만들기</span>
                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </dd>
                                        </dl>
                                    </fieldset>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
        );
    }
}

export default PopupAdminClassroom;



// WEBPACK FOOTER //
// ./src/components/Containers/PopupAdminClassroom/index.js